import React from 'react'
import {Route, Redirect} from 'react-router-dom'
import {FrontendRoutes} from "../constants";

const PrivateRoute = ({user, ...rest}) => {

    // if(!user)
    //     return <Redirect to={FrontendRoutes.AFTER_EVENT_MESSAGE}/>
    return (<Route {...rest}/>);
}


export default PrivateRoute